import * as React from "react";
const SvgOplatiIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M19 23H5v-4h14v4ZM5 19H1V5h4v14Zm18 0h-4V5h4v14ZM19 5H5V1h14v4Z" }));
export default SvgOplatiIcon;
